import React, { useState, useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../styles/Winner.css'; // Import your custom CSS file
import OriginIcon from '../assets/images/co1.webp';
import BoatImage from '../assets/images/coconutposterpngfinal2.png';
import VivoImage from '../assets/images/coconutposterpngfinal2.png';
import FireboltImage from '../assets/images/coconutposterpngfinal2.png';
import product1 from "../assets/images/co1.webp";
import product2 from "../assets/images/groundnutpng3.png";
import product3 from "../assets/images/sesameposterpng2.png";
import product4 from "../assets/images/mustardposterpng.png";
import product5 from "../assets/images/deepamposterpng.png";
import product6 from "../assets/images/castoroilposter1.png";
import chips2 from "../assets/images/chocolate.png";
import chips3 from "../assets/images/chocolate_original_2_11zon.webp";
import chips4 from "../assets/images/cholate_vanila_4_11zon.webp";
import chips5 from "../assets/images/chocolate_ll_three_package_1_11zon.png";
import butterunsweet from "../assets/images/PEANUT BUTTER Unsweetened .webp"
import butterJuggery from "../assets/images/PEANUT BUTTER JAGGERY .webp"
import butterChoclate from "../assets/images/PEANUT BUTTER CHOCOLATE .webp"


const winnerData = {
  origin: [
    { title: 'Coconut Oil', image: product1 },
    { title: 'Vivo', image: product2 },
    { title: 'Fire Bolt', image: product3 },
    { title: 'Fireboltt', image: product4 },
    { title: 'Spotlight Product 2', image: product5 },
    { title: 'Spotlight Product 2', image: product6 },
  ],
  ace: [
    { title: 'Boat', image: chips2 },
    { title: 'Vivo',  image: chips3 },
    { title: 'Fire Bolt',  image: chips4 },
    { title: 'Fireboltt',  image: chips5 },
  ],
  vivid: [
    { title: 'Boat', subtitle: 'Nirvana ION Campaign - <span class="medal gold">Gold</span>', image: butterunsweet },
    { title: 'Vivo', subtitle: 'Campaign Name - <span class="medal silver">Silver</span>', image: butterJuggery },
    { title: 'Fire Bolt', subtitle: 'Campaign Name - <span class="medal bronze">Bronze</span>', image: butterChoclate },
  ],
  // meld: [
  //   { title: 'Boat', subtitle: 'Nirvana ION Campaign - <span class="medal gold">Gold</span>', image: BoatImage },
  //   { title: 'Vivo', subtitle: 'Campaign Name - <span class="medal silver">Silver</span>', image: VivoImage },
  //   { title: 'Fire Bolt', subtitle: 'Campaign Name - <span class="medal bronze">Bronze</span>', image: FireboltImage },
  // ],
  novel: [
    { title: 'Fire Bolt', subtitle: 'Campaign Name - <span class="medal silver">Silver</span>', image: VivoImage },
    { title: 'Fire Bolt', subtitle: 'Campaign Name - <span class="medal silver">Silver</span>', image: BoatImage },
    { title: 'Fire Bolt', subtitle: 'Campaign Name - <span class="medal silver">Silver</span>', image: BoatImage },
    { title: 'Fire Bolt', subtitle: 'Campaign Name - <span class="medal silver">Silver</span>', image: VivoImage },
    { title: 'Fire Bolt', subtitle: 'Campaign Name - <span class="medal silver">Silver</span>', image: FireboltImage },
  ],
  spotlight: [
    { title: 'Fireboltt', subtitle: 'Rakhi Campaign - <span class="medal bronze">Bronze</span>', image: BoatImage },
    { title: 'Spotlight Product 2', subtitle: 'Campaign Name - <span class="medal gold">Gold</span>', image: VivoImage },
    { title: 'Boat', subtitle: 'Nirvana ION Campaign - <span class="medal gold">Gold</span>', image: BoatImage },
    { title: 'Vivo', subtitle: 'Campaign Name - <span class="medal silver">Silver</span>', image: VivoImage },
    { title: 'Fire Bolt', subtitle: 'Campaign Name - <span class="medal bronze">Bronze</span>', image: FireboltImage },
  ],
};

const WinnerSlider = () => {
  const [activeTab, setActiveTab] = useState('origin');
  const sliderRefs = useRef({});

  const settings = {
    dots: false,
    infinite: true, // Enable infinite looping for auto-slide
    speed: 500,
    slidesToShow: 3,
    arrows: true,
    slidesToScroll: 3, // Slide one at a time for smoother auto-slide
    autoplay: false, // Enable auto-play
    autoplaySpeed: 1800, // Set auto-play speed in milliseconds (e.g., 3000ms = 3 seconds)
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '20px',
        },
      },
    ],
  };

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    if (sliderRefs.current[tabId]) {
      sliderRefs.current[tabId].slickGoTo(0); // Go to the first slide when switching tabs
    }
  };

  return (
    <article className="winnerContainer" id="winnerContainerTabs">
      <h3>All time Best sellers</h3>
      <div className="winnertabsContainer">
        <button
          className={`tab ${activeTab === 'origin' ? 'active' : ''}`}
          data-tab="origin"
          onClick={() => handleTabClick('origin')}
        >
          <span>
            <img src={OriginIcon} alt="origin" />
          </span>
          Oils
        </button>
        <button
          className={`tab ${activeTab === 'ace' ? 'active' : ''}`}
          data-tab="ace"
          onClick={() => handleTabClick('ace')}
        >
          <span>
            <img src={chips2} alt="main" />
          </span>
          Chips
        </button>
        <button
          className={`tab ${activeTab === 'vivid' ? 'active' : ''}`}
          data-tab="vivid"
          onClick={() => handleTabClick('vivid')}
        >
          <span>
            <img src={butterChoclate} alt="vivid" />
          </span>
          Butter
        </button>
        {/* <button
          className={`tab ${activeTab === 'meld' ? 'active' : ''}`}
          data-tab="meld"
          onClick={() => handleTabClick('meld')}
        >
          <span>
            <img src={MeldIcon} alt="meld" />
          </span>
          Honey
        </button> */}
        {/* <button
          className={`tab ${activeTab === 'novel' ? 'active' : ''}`}
          data-tab="novel"
          onClick={() => handleTabClick('novel')}
        >
          <span>
            <img src={NovelIcon} alt="novel" />
          </span>
          Novel
        </button>
        <button
          className={`tab ${activeTab === 'spotlight' ? 'active' : ''}`}
          data-tab="spotlight"
          onClick={() => handleTabClick('spotlight')}
        >
          <span>
            <img src={SpotlightIcon} alt="spotlight" />
          </span>
          Spotlight
        </button> */}
      </div>

      <div className="slider-container-winner">
        {Object.keys(winnerData).map((key) => (
          <div
            key={key}
            id={`${key}-slider`}
            className={`winners-slider ${activeTab === key ? 'active' : ''}`}
          >
            <Slider ref={(c) => (sliderRefs.current[key] = c)} {...settings}>
              {winnerData[key].map((winner, index) => (
                <div className="winner-card" key={index}>
                  <div className="winner-image">
                    <picture>
                      {/* <source media="(max-width:767px)" srcSet={BoatMobileImage} className="img-fluid" /> */}
                      <img src={winner.image} className="img-fluid" alt={winner.title} />
                    </picture>
                    <div className="winner-info">
                      {/* <h2 className="winner-title">{winner.title}</h2> */}
                      {/* <p
                        className="winner-subtitle"
                        dangerouslySetInnerHTML={{ __html: winner.subtitle }}
                      ></p> */}
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        ))}
      </div>
    </article>
  );
};

export default WinnerSlider;